import { gql } from '@apollo/client';

export const supplierProductsQuery = gql`
  query ($personId: Int!) {
    suppliersProducts(personId: $personId) {
      productId
      productName
      productGroupId
      productGroupName
      productDivisionName
    }
  }
`;
